/**
 * Chip for a Launch Resource type.
 */

import React from 'react';

import {Chip} from './Chip';

type ResourceChipProps = {
  value: string;
};

export const ResourceChip = ({value}: ResourceChipProps) => {
  switch (value) {
    case 'vertex':
      return (
        <Chip icon="vertex-gcp" label="GCP Vertex" dataTest="resource-chip" />
      );
    case 'sagemaker':
      return (
        <Chip
          icon="amazon-sagemaker"
          label="Sagemaker"
          dataTest="resource-chip"
        />
      );
    case 'kubernetes':
      return (
        <Chip icon="kubernetes" label="Kubernetes" dataTest="resource-chip" />
      );
    case 'local-container':
      return (
        <Chip icon="docker-whale" label="Docker" dataTest="resource-chip" />
      );
    case 'local-process':
      return (
        <Chip
          icon="laptop-local-computer"
          label="Local process"
          dataTest="resource-chip"
        />
      );
    case 'unknown':
      // It's possible to create a queue without specifying a default resource config.
      return null;
  }
  console.error(`Don't know how to render resource chip for ${value}`);
  return null;
};
